import $ from 'jquery';
import 'jquery-mask-plugin';

/**
 * @type {function(HTMLElement): {phone: string[], money: string}}
 * @param {HTMLElement} element
 * */
const findMaskForElement = (element) => {
  const mexicanPhoneOptions = () => ({
    onKeyPress: (phone, _e, field, options) => {
      const masks = {
        short: '(00) 0000-00009',
        long: '(000) 0000-0000',
      };

      const MAX_LENGTH_FOR_SHORT_MASK = 14;
      const mask = phone.length > MAX_LENGTH_FOR_SHORT_MASK ? masks.long : masks.short;
      field.mask(mask, options);
    },
  });

  const maskByCountry = {
    default: {
      phone: ['(00) 00000-0000'],
      landline: '(00) 0000-0000',
      money: '00000000000,00',
    },
    'es-CL': {
      phone: ['(0) 0000-0000'],
      money: '00000000000.00',
    },
    'es-MX': {
      phone: ['(00) 0000-0000', mexicanPhoneOptions()],
      money: '00000000000.00',
    },
  };
  maskByCountry.mx = maskByCountry['es-MX'];

  const countryKey = Object
    .keys(maskByCountry)
    .find((countryClass) => $(element).hasClass(countryClass));

  return maskByCountry[countryKey] ?? maskByCountry.default;
};

// Phone Mask
export const addPhoneMask = () => {
  $('.phone_with_ddd,.phone_with_ddi').each(function () {
    const value = $(this).val();
    const countryMask = findMaskForElement(this);
    // Landline fields (e.g. contact "telefone") use the 8-digit mask where the
    // country defines one; mobile/default keeps the country phone mask.
    const useLandline = $(this).hasClass('phone_landline') && countryMask.landline;
    const mask = useLandline ? countryMask.landline : countryMask.phone[0];
    const options = useLandline ? {} : (countryMask.phone[1] || {});
    $(this).mask(mask, options);
    $(this).val(value).trigger('input').trigger('change.mask');
  });
};

addPhoneMask();
document.querySelector('body').addEventListener('refreshPhoneMasks', addPhoneMask);
// End Phone Mask

// Money Mask
export const applyMoneyMask = (contextRef, options = { reverse: true }) => {
  const normalizedDecimalString = $(contextRef)
    .val()
    .replace(',', '.')
    .replace(/[^0-9.-]+/g, '');
  const value = parseFloat(normalizedDecimalString).toFixed(2);
  $(contextRef).val(value);

  const countryMask = findMaskForElement(contextRef);
  const appliedMask = countryMask.money;
  $(contextRef).mask(appliedMask, options);
};

export const clearMask = (contextRef) => {
  $(contextRef).unmask();
};

$('.money').each(function () {
  applyMoneyMask(this);
});
// End Money Mask

$(() => {
  $('.zip-code-pt-BR').mask('00000-000');
});
$('.cnpj').mask('AA.AAA.AAA/AAAA-00');
$('.cpf').mask('000.000.000-00');
$('.credit-card-number').mask('0000-0000-0000-0000');
$('.expiry_month').mask('00');
$('.expiry_year').mask('0000');
$('.date-mask').mask('00/00/0000');
$('.phone-confirmation-code').mask('0 0 0 0 0 0');
$('.state-field.pt-BR').mask('SS');
